import { render, staticRenderFns } from "./innerBanner.vue?vue&type=template&id=47b4f0a5&scoped=true&"
import script from "./innerBanner.vue?vue&type=script&lang=js&"
export * from "./innerBanner.vue?vue&type=script&lang=js&"
import style0 from "./innerBanner.vue?vue&type=style&index=0&id=47b4f0a5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b4f0a5",
  null
  
)

export default component.exports